import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres7fe/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres7fe/columnsLabels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    let dteyear = ''
    dteyear = (typeof searchParams.year !== 'undefined' ? searchParams.year : '')
    sendParams = {
      p_dtetrst: (typeof searchParams.dtestrt !== 'undefined' ? searchParams.dtestrt : ''),
      p_dtetren: (typeof searchParams.dtetren !== 'undefined' ? searchParams.dtetren : ''),
      p_codcours: (typeof searchParams.codcours !== 'undefined' ? searchParams.codcours : ''),
      p_numclseq: (typeof searchParams.numclseq !== 'undefined' ? searchParams.numclseq : '')
    }
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hres7fe/index/' + dteyear, { params: sendParams })
  },
  getDetail (searchParams) {
    let dataParams = {
      p_dteyear: searchParams.year,
      p_codcours: searchParams.codcours,
      p_numclseq: searchParams.numclseq
    }
    if (isMock) return generator(mocker.detail())
    const params = dataParams.p_dteyear + '/' + dataParams.p_codcours + '/' + dataParams.p_numclseq
    return instance().get(endpoint + '/hres7fe/detail/' + params)
  },
  postSaveDetailTab1 ({ searchIndex, indexSelected, detailTab1 }) {
    let sendParams = {
      param_json: JSON.stringify({
        codempid: indexSelected.codempid,
        dteyear: searchIndex.year,
        codcours: indexSelected.codcours,
        numclseq: indexSelected.numclseq,
        codappr: indexSelected.codappr,
        detail: detailTab1.detail,
        table1: detailTab1.table1
      })
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres7fe/detailTab1Save', sendParams)
  },
  postSaveDetailTab2 ({ searchIndex, indexSelected, detailTab2 }) {
    let sendParams = {
      param_json: JSON.stringify({
        dteyear: searchIndex.year,
        codcours: indexSelected.codcours,
        numclseq: indexSelected.numclseq,
        dessummary: detailTab2.dessummary,
        desbenefit: detailTab2.desbenefit,
        descomment: detailTab2.descomment
      })
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres7fe/detailTab2Save', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres7fe/index.js